/**
 * Web-search citations, rendered from AI SDK `source-url` parts (the backend
 * forwards them via sendSources). AI-Elements-style compact source list.
 */

import React from 'react';
import { Box, Chip, Link, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import type { SourceCitation } from '../engine/parts';

interface SourcesProps {
  citations: SourceCitation[];
}

function hostOf(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

const Sources: React.FC<SourcesProps> = ({ citations }) => {
  if (citations.length === 0) return null;

  return (
    <Box sx={{ mt: 1 }}>
      <Typography
        variant="caption"
        sx={{ fontWeight: 600, color: 'text.secondary', display: 'block', mb: 0.5 }}
      >
        Sources
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {citations.map((c, i) => (
          <Chip
            key={c.sourceId}
            component={Link}
            href={c.url}
            target="_blank"
            rel="noopener noreferrer"
            clickable
            size="small"
            icon={<OpenInNewIcon sx={{ fontSize: 14 }} />}
            label={`${i + 1}. ${c.title?.trim() || hostOf(c.url)}`}
            sx={{
              maxWidth: 260,
              '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' },
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default React.memo(Sources);
